/**
 * Dispatch event to trigger mismatch check in Header
 */
export const triggerMismatchCheck = () => {
    window.dispatchEvent(new CustomEvent('quoteMismatchCheck'));
};
